import { Annotation } from "../../annotations/shared/annotation";
import { Visibility } from "../../rl-common/shared/shared/types/visibility.enum";
import { EntityType } from "../shared/shared/entity-type.enum";
export class Comment {
    title : string;
    date : Date;
    attachedId : string;
    page : number;
    visibility : Visibility;
    user : any;
    parentAttachedId? : string;
    subComments? : Comment[] = [];
    canReply? : boolean;
    // [key : string] : any;

    entityType : EntityType;
    offsetTop : any;
    offsetLeft : any;
    isNew : boolean = false;

    constructor(a? : Annotation){
        if(!a) return;     
        this.entityType = a.entityType;
        this.date = new Date(a.modificationDate);
        this.title = a.text;
        this.attachedId = a.id;
        this.isNew = !a.id;
        this.page = a.page;
        if(a.attributes){
            let attr = typeof a.attributes === 'string' ? JSON.parse(a.attributes) : a.attributes;
            this.offsetTop = attr.offsetTop;
            this.offsetLeft = attr.offsetLeft;
        }
        if(a.offsetTop != undefined && a.offsetLeft != undefined){
            this.offsetTop = a.offsetTop;
            this.offsetLeft = a.offsetLeft;
        }

        this.visibility = a.visibility;
        this.user = a.user;
        this.canReply = a.canReply;
    
        a.annotations?.forEach(subAnn => this.subComments.push(Object.assign(new Comment(subAnn), {parentAttachedId : this.attachedId})));
    }
}
